import type { IconData } from '@stacksjs/iconify-core'

export const columns: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M11 2h2v20h-2z\" opacity=\".25\"/><path fill=\"currentColor\" d=\"M3 2h8v20H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1\"/><path fill=\"currentColor\" d=\"M13 2h8a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1h-8z\" opacity=\".5\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default columns
